import InexCard from "../InexCard";
import { Box, Typography } from "@mui/material";
import RainbowDivider from "../misc/RainbowDivider";
import React from "react";
import { useGetEventDatesQuery } from "../../store/api/events";
import moment from "moment";
import EventDate from "./EventDate";
import EventPlace from "./EventPlace";
import InexButton from "../InexButton";

import { ArrowForwardRounded } from "@mui/icons-material";

import { ReactComponent as Level1Icon } from "../../resources/images/svg/home/profile/level1.svg";
import { ReactComponent as Level2Icon } from "../../resources/images/svg/home/profile/level2.svg";
import DOMPurify from 'dompurify';
import { useEffect } from "react";

const EventCard = ({ event, level }) => {
  const { data } = useGetEventDatesQuery({ id: event.id });
  const [isFull, setIsFull] = React.useState(false); 

  const dates = React.useMemo(() => {
    if (!data) return [];
    return data.dates;
  }, [data]);

  const description = React.useMemo(() => {
    //return DOMPurify.sanitize(event?.description.replaceAll("\\", "") || "");
    return (event?.description.replaceAll("\\", "") || "").replace(/<[^>]*>/g, ' ');
  }, [event])

  const nextDate = React.useMemo(() => {
    const now = moment();
    return dates
      .filter((d) => {
        const end = moment(d.dateFin * 1000);
        return end.isAfter(now);
      })
      .sort((a, b) => {
        const start1 = moment(a.dateDebut * 1000);
        const start2 = moment(b.dateDebut * 1000);
        return start1.diff(start2);
      })[0];
  }, [dates]);

  useEffect(() => {
    setIsFull(nextDate && (nextDate?.stock - nextDate?.vendu <= 0))
  }, [nextDate])

  return (
    <InexCard
      sx={{
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0,
        display: "flex",
        flexDirection: "column",
        minWidth: "100%",
        height: "100%",
        minHeight: "100%",
        userSelect: "none",
        flexGrow: 1,
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative",
          aspectRatio: 400 / 340,
          height: 340,
          minHeight: 340,
          width: "100%",
          "& > img": {
            objectFit: "cover",
            width: "100%",
            cursor: "pointer",
          },
        }}
        onClick={() => {
          window.open(
            `https://boutique.inexplore.com/evenement/${event.slug}`,
            "_blank",
          );
        }}
      >
        <img
          src={`https://medias.inrees.com/img/agenda/affiche_${event?.id}.jpg`}
          alt={"eventImage"}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          padding: "15px",
          display: "flex",
          alignItems: "flex-start",
          height: "100%",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            justifyContent: "space-between",
            flexGrow: 1,
            mt: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Yesevaone SemiBold !important",
                fontSize: "24px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                color: "black",
                verticalAlign: "top",
                fontWeight: "bold",
                maxHeight: "100%",
              }}
            >
              {event.titre}
            </Typography>
            <Typography
              mt={2}
              sx={{
                fontFamily: "Branding SemiBold",
                fontSize: "16px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                color: "black",
                verticalAlign: "top",
                textWrap: "break-word",
                maxHeight: "10em",
                lineHeight: "1.4"
              }}
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
            <a
              href={`https://boutique.inexplore.com/evenement/${event.slug}`}
              target="_blank"
            >
              <Typography
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontWeight: "semi-bold",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                En savoir plus
              </Typography>
            </a>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            marginTop: 2,
          }}
        >
          <EventDate date={nextDate} />
          <EventPlace
            date={nextDate}
            sx={{
              marginTop: 2,
            }}
          />
          {level >= 2 ? (
            <a
              href={`https://boutique.inexplore.com/evenement/${event.slug}`}
              target="_blank"
            >
              <InexButton
                text={isFull ? "COMPLET !" : "Je m'inscris à cet évenement"}
                disabled={isFull}
                variant={"text"}
                textWithGradient={false}
                onClick={() => {}}
                sx={{
                  zIndex: 1,
                  marginTop: 2,
                  width: "100%",
                  height: "50px",
                  background: (theme) => isFull ? theme.palette.grey[300] : theme.palette.yellowPro,
                  border: "none",
                  color: (theme) => theme.palette.blackPro,
                  "&:hover": {
                    backgroundColor: (theme) => isFull ? null : theme.palette.primary.main,
                    "& > p": {
                      color: "white",
                    },
                  },
                }}
              />
            </a>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 2,
                padding: 1,
                backgroundColor: (theme) => theme.palette.grey[300],
                borderRadius: "25px",
                height: "50px",
              }}
            >
              <Level1Icon
                style={{
                  width: "31px",
                  height: "31px",
                  marginRight: "5px",
                }}
              />
              <ArrowForwardRounded
                sx={{
                  marginRight: "5px",
                }}
              />
              <Level2Icon
                style={{
                  width: "31px",
                  height: "31px",
                  marginRight: "12px",
                }}
              />
              <Typography
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontWeight: "900",
                  fontSize: "16px",
                  cursor: "pointer"
                }}
                onClick={() => {
                  window.open("https://eu1.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhAMvJ1RIIr34F-s1uAFk7RN5A-_VnhyXbFe4ALBajwlQP_cihgZEyzvK62wwqFh8ws", "_blank", "noopener,noreferrer");
                }}
              >
                Accédez au palier 2 pour vous inscrire
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <RainbowDivider
        sx={{
          marginTop: "auto",
          zIndex: 1,
          height: "3px",
        }}
      />
    </InexCard>
  );
};

export default EventCard;
